import { createSelector } from 'reselect'

import { selectComposedReportState } from './selectComposedReportState'

export const selectSpecializationsSelectValue = createSelector(
  [selectComposedReportState],
  ({ specializations }) => specializations
)
